/*
This file was generated by the Surface compiler.
*/

function ns(hooks, nameSpace) {
  const updatedHooks = {}
  Object.keys(hooks).map(function(key) {
    updatedHooks[`${nameSpace}#${key}`] = hooks[key]
  })
  return updatedHooks
}

import * as c1 from "./EnaiaWeb.Surface.AllAccounts.hooks.js"
import * as c2 from "./EnaiaWeb.Surface.AttachmentFileThumbnail.hooks.js"
import * as c3 from "./EnaiaWeb.Surface.Dialogs.PopupHeader.hooks.js"
import * as c4 from "./EnaiaWeb.Surface.Dialogs.PopupHeaderExtended.hooks.js"
import * as c5 from "./EnaiaWeb.Surface.FilesComponent.hooks.js"
import * as c6 from "./EnaiaWeb.Surface.Forms.PartnersForm.hooks.js"
import * as c7 from "./EnaiaWeb.Surface.Inputs.AutocompleteInput.hooks.js"
import * as c8 from "./EnaiaWeb.Surface.Inputs.AutocompleteSelect.hooks.js"
import * as c9 from "./EnaiaWeb.Surface.Inputs.CompanySelector.hooks.js"
import * as c10 from "./EnaiaWeb.Surface.Inputs.CurrencyInput.hooks.js"
import * as c11 from "./EnaiaWeb.Surface.Inputs.PlaceSelector.hooks.js"
import * as c12 from "./EnaiaWeb.Surface.Inputs.RepresentationTypeSelector.hooks.js"
import * as c13 from "./EnaiaWeb.Surface.Inputs.Select.hooks.js"

let hooks = Object.assign(
  ns(c1, "EnaiaWeb.Surface.AllAccounts"),
  ns(c2, "EnaiaWeb.Surface.AttachmentFileThumbnail"),
  ns(c3, "EnaiaWeb.Surface.Dialogs.PopupHeader"),
  ns(c4, "EnaiaWeb.Surface.Dialogs.PopupHeaderExtended"),
  ns(c5, "EnaiaWeb.Surface.FilesComponent"),
  ns(c6, "EnaiaWeb.Surface.Forms.PartnersForm"),
  ns(c7, "EnaiaWeb.Surface.Inputs.AutocompleteInput"),
  ns(c8, "EnaiaWeb.Surface.Inputs.AutocompleteSelect"),
  ns(c9, "EnaiaWeb.Surface.Inputs.CompanySelector"),
  ns(c10, "EnaiaWeb.Surface.Inputs.CurrencyInput"),
  ns(c11, "EnaiaWeb.Surface.Inputs.PlaceSelector"),
  ns(c12, "EnaiaWeb.Surface.Inputs.RepresentationTypeSelector"),
  ns(c13, "EnaiaWeb.Surface.Inputs.Select")
)

export default hooks
